import { useTranslation } from 'react-i18next';

import { useAuth } from '@/contexts/AuthContext';

export function useGreeting(): string {
  const { user } = useAuth();
  const { t } = useTranslation('providers');
  const hour = new Date().getHours();
  const name = user?.firstName || t('greeting.fallbackName');
  if (hour < 12) return t('greeting.morning', { name });
  if (hour < 18) return t('greeting.afternoon', { name });
  return t('greeting.evening', { name });
}
